var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1155 20C7.668 20 7.28683 19.8426 6.972 19.528C6.65733 19.2131 6.5 18.832 6.5 18.3845V5.99996H5.5V4.99996H9.5V4.23071H15.5V4.99996H19.5V5.99996H18.5V18.3845C18.5 18.8448 18.3458 19.2291 18.0375 19.5375C17.7292 19.8458 17.3448 20 16.8845 20H8.1155ZM17.5 5.99996H7.5V18.3845C7.5 18.564 7.55767 18.7115 7.673 18.827C7.7885 18.9423 7.936 19 8.1155 19H16.8845C17.0385 19 17.1796 18.9359 17.3077 18.8077C17.4359 18.6795 17.5 18.5385 17.5 18.3845V5.99996ZM10.3078 17H11.3078V7.99996H10.3078V17ZM13.6923 17H14.6923V7.99996H13.6923V17Z",
    fill: "#E96F0C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7d9bb3b96c2c1a86bb8f8cd4e83ebdc2.svg";
export { ForwardRef as ReactComponent };